import BeforeLogin from "./BeforeLogin";
import AfterLogin from "./AfterLogin";
import { RootProps } from "routes";
import "./Header.scss";

const Header = (props: RootProps) => {
  const { user } = props;

  if (user) {
    return <AfterLogin {...props} />;
  } else {
    return <BeforeLogin {...props} />;
  }
};

export default Header;
